'use client';
import { ensureNativeModulesAreInstalled } from './ensureNativeModulesAreInstalled';
ensureNativeModulesAreInstalled();
export const SharedObject = globalThis.expo.SharedObject;

//# sourceMappingURL=SharedObject.js.map
